/* eslint-disable jsx-a11y/anchor-is-valid */
import moment from 'moment'
import {FC, useEffect, useState} from 'react'
import {yupResolver} from '@hookform/resolvers/yup'
import {InputDate} from '../../../../../../components/UI/Input'
import {Column} from 'react-table'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {GuestFileModel} from '../../model'
import {getOpaGuestFileService} from '../../service/bookingInt'
import {ModalDetailBooking} from '../Modals/ModalDetailBooking'
import {FormProvider, useForm} from 'react-hook-form'
import {Button, ButtonWrapper} from '../../../../../../components/UI/Button'

const TableUploadGuest: FC = () => {
  const {data, setData, setPagination, loading, setLoading, pagination} = useKTable()
  const [showModal, setShowModal] = useState(false)
  const [bookingtoShow, setBookingToShow] = useState<GuestFileModel | any>(null)
  const [formValue, setFormValue] = useState<any>(null)
  const [formValueLoading, setFormValueLoading] = useState<any>(false)
  const {currentTabItem} = useHoteleria()
  const methods = useForm<GuestFileModel>()
  const {
    formState: {errors},
    register,
    handleSubmit,
    reset,
  } = methods
  const getUploadBookings = async () => {
    try {
      if (!formValue) return
      setLoading(true)
      let obj = {...formValue}
      const {data: response} = await getOpaGuestFileService(obj, pagination.currentPage)
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (formValueLoading) {
      setFormValueLoading(false)
      getUploadBookings()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formValueLoading])

  const handleClear = () => {
    reset()
    setFormValue(null)
    setData([])
  }
  const onSubmit = (dataForm: GuestFileModel) => {
    setPagination({
      ...pagination,
      currentPage: 1,
      perPage: 10,
      totalResults: 0,
    })
    setFormValue(dataForm)
    setFormValueLoading(true)
  }
  useEffect(() => {
    getUploadBookings()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const handleShowDetail = (item: GuestFileModel) => {
    setBookingToShow(item)
    setShowModal(true)
  }
  useEffect(() => {
    if (currentTabItem.trayUpdated) {
      getUploadBookings()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.trayUpdated])

  const columns: Column<GuestFileModel>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} title='Archivo' />,
      accessor: 'nombreArchivo',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de Bandeja' />,
      accessor: 'tipoBandeja',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Registros cargados' />,
      accessor: 'registrosProcesados',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Registros aceptados' />,
      accessor: 'registrosAceptados',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Registros rechazados' />,
      accessor: 'registrosRechazados',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Fecha de carga' />,
      accessor: 'fechaRegistro',
      Cell: ({...props}) => (
        <div>{moment(props.row.original.fechaRegistro).local().format('DD/MM/YYYY HH:mm:ss')}</div>
      ),
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
      id: 'actions_ver',
      Cell: ({...props}) => (
        <div
          className='d-flex justify-content-center flex-shrink-0'
          onClick={() => handleShowDetail(props.row.original)}
        >
          <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
            <KTSVG path='/media/icons/duotune/general/gen004.svg' className='svg-icon-3' />
          </a>
        </div>
      ),
    },
  ]

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  return (
    <>
      <KTCard shadow className='m-5'>
        <FormProvider {...methods}>
          <form className='m-2'>
            <div className='row'>
              <div className='col-sm-12 col-lg-3'>
                <label>Fecha de Creación de Datos:</label>
                <InputDate name='FechaInicio' register={register} errors={errors} />
              </div>
              <div className='col-sm-12 col-lg-3'>
                <label>Fecha Fin de Creación de Datos:</label>
                <InputDate name='FechaFin' register={register} errors={errors} />
              </div>
            </div>
          </form>
          <ButtonWrapper className={'sdx-white-bg'}>
            <Button label='Buscar' onClick={handleSubmit(onSubmit)} />
            <Button label='Limpiar' onClick={handleClear} />
          </ButtonWrapper>
        </FormProvider>
        <KTable data={data} columns={columns} />
        {loading ? <KTableLoading title='Cargando...' /> : null}
        <ModalDetailBooking show={showModal} setShow={setShowModal} bookingToShow={bookingtoShow} />
      </KTCard>
    </>
  )
}

const TableUploadGuestWrapper = () => {
  return (
    <KTableProvider>
      <TableUploadGuest />
    </KTableProvider>
  )
}

export {TableUploadGuestWrapper}
